import { render, staticRenderFns } from "./PorezForma.vue?vue&type=template&id=15837af2&scoped=true&"
import script from "./PorezForma.vue?vue&type=script&lang=js&"
export * from "./PorezForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15837af2",
  null
  
)

export default component.exports